import React from 'react'

import { Typography, Box } from '@material-ui/core'

import { BaseDialog } from 'components'

import theme from 'theme'

const DocumentConfigurationDialog = ({
  open,
  setOpen,
  actionButton,
  closeButtonAction,
}) => {
  return (
    <BaseDialog
      title="Atenção: Publicar Documento"
      open={open}
      setOpen={setOpen}
      actionButton={actionButton}
      closeButtonText="Cancelar"
      actionButtonText="Prosseguir"
      closeButtonAction={closeButtonAction}
    >
      <Box
        display="flex"
        flexDirection="column"
        textAlign="justify"
        gridGap={theme.spacing(1.5)}
      >
        <Typography variant="body1">
          Ao ativar a opção{' '}
          <strong>
            "Publicar no Canal de Atendimento ao Títular de Dados"
          </strong>
          , este documento se tornará público e seu conteúdo ficará{' '}
          <strong>visível para qualquer pessoa </strong> com acesso ao canal.
        </Typography>

        <Typography variant="body1">
          <strong>Não utilize essa opção se o documento:</strong>
        </Typography>

        <Box component="ul" sx={{ pl: 2 }}>
          <Typography component="li" variant="body1">
            For <strong>interno</strong> ou <strong>confidencial</strong> da
            empresa;
          </Typography>
          <Typography component="li" variant="body1">
            Contiver <strong>dados pessoais</strong> ou{' '}
            <strong>informações sensíveis</strong>;
          </Typography>
          <Typography component="li" variant="body1">
            Se referir{' '}
            <strong>exclusivamente a uma pessoa ou caso específico.</strong>
          </Typography>
        </Box>
        <Typography paragraph variant="body1">
          Use essa opção{' '}
          <strong>apenas para documentos destinados ao acesso público </strong>,
          como políticas, comunicados gerais ou informações institucionais.
        </Typography>
      </Box>
    </BaseDialog>
  )
}

export default DocumentConfigurationDialog
